// Core UI translations for Omni
// AI responses are translated via system prompt - this handles UI elements only

const translations = {
  en: {
    // Nav
    "nav.chat": "Chat",
    "nav.bookmarks": "Bookmarks",
    "nav.mood": "Mood",
    "nav.therapy": "Therapy",
    "nav.timeline": "Timeline",
    "nav.goals": "Goals",
    "nav.insights": "Insights",
    "nav.plans": "Plans",
    "nav.gift": "Gift",
    "nav.family": "Family",
    "nav.group": "Group Admin",
    "nav.settings": "Settings",
    "nav.guide": "Guide",
    "nav.share": "Share",
    "nav.calendar": "Calendar",
    "nav.admin": "Dashboard",
    "nav.logout": "Log out",
    // Chat
    "chat.newChat": "New Chat",
    "chat.placeholder": "What's on your mind?",
    "chat.hello": "Hello,",
    "chat.welcome": "I'm here whenever you need me. Ask me anything, share what's on your mind, or just say hello.",
    "chat.disclaimer": "Omni is an AI companion. Not a licensed professional. In a crisis, contact emergency services.",
    "chat.cbtDisclaimer": "CBT exercises are for self-reflection only and do not replace professional therapy. If you have persistent mental health concerns, please consult a qualified professional.",
    "chat.export": "Export PDF",
    "chat.share": "Share",
    // Mood
    "mood.title": "Mood",
    "mood.howFeeling": "How are you feeling?",
    "mood.log": "Log Mood",
    "mood.history": "History",
    "mood.insights": "Insights",
    "mood.reminder": "Daily Check-in",
    "mood.reminderDesc": "Get a gentle reminder to check in with yourself",
    "mood.reminderTime": "Reminder Time",
    "mood.reminderToast": "How are you feeling today? Take a moment to check in with yourself.",
    // Goals
    "goals.title": "Goals",
    "goals.create": "New Goal",
    "goals.empty": "No goals yet. Start with something small!",
    // Pricing
    "pricing.title": "Choose your path",
    "pricing.subtitle": "Start free. Grow when you're ready.",
    "pricing.monthly": "Monthly",
    "pricing.annual": "Annual",
    "pricing.annualSave": "save 17%",
    "pricing.freeForever": "Free Forever",
    "pricing.upgrade": "Upgrade",
    "pricing.currentPlan": "Current Plan",
    "pricing.checkout": "Checkout",
    "pricing.confirm": "Confirm Payment",
    "pricing.cancel": "Cancel",
    "pricing.demoMode": "Demo Mode: No real payment will be charged. Click confirm to test.",
    // Family
    "family.title": "Family",
    "family.create": "Create Your Family Group",
    "family.inviteCode": "Invite Code",
    "family.copy": "Copy",
    "family.newCode": "New Code",
    "family.members": "Members",
    "family.addMember": "Add Member",
    "family.trends": "Emotional Trends",
    "family.trendsDesc": "See how your family is doing emotionally. Private messages are never visible.",
    "family.joinCode": "Have an invite code?",
    "family.join": "Join",
    "family.planRequired": "Family Plan Required",
    // Settings
    "settings.title": "Settings",
    "settings.appearance": "Appearance",
    "settings.theme": "Theme",
    "settings.font": "Font",
    "settings.voice": "Voice",
    "settings.autoRead": "Auto-read AI replies",
    "settings.autoReadDesc": "Omni will speak responses aloud",
    "settings.omniVoice": "Omni's Voice",
    "settings.wakeWord": "Wake Word",
    "settings.wakeWordDesc": 'Say "Hey Omni" to start voice input on chat page',
    "settings.profile": "Profile",
    "settings.username": "Username",
    "settings.preferredName": "Preferred Name",
    "settings.email": "Email (optional)",
    "settings.save": "Save Changes",
    "settings.language": "Language",
    "settings.languageDesc": "Changes AI responses and interface language",
    "settings.privacy": "Privacy & Data",
    "settings.deleteAccount": "Delete Account",
    "settings.deleteConfirm": "This will permanently delete your account and all data. Are you sure?",
    "settings.delete": "Yes, Delete Everything",
    // Common
    "common.loading": "Loading...",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.error": "Something went wrong",
    "common.success": "Success",
    "common.avgMood": "avg mood",
    "common.stable": "Stable",
    "common.improving": "Improving",
    "common.declining": "Declining",
    "common.guardian": "Guardian",
    "common.member": "Member",
    "common.noData": "No data yet",
  },

  // --- French ---
  fr: {
    "nav.chat": "Discussion", "nav.mood": "Humeur", "nav.goals": "Objectifs",
    "nav.plans": "Abonnements", "nav.family": "Famille", "nav.settings": "Paramètres", "nav.logout": "Déconnexion",
    "chat.newChat": "Nouvelle discussion", "chat.placeholder": "Qu'avez-vous en tête ?",
    "chat.hello": "Bonjour,", "chat.welcome": "Je suis là quand vous avez besoin de moi. Posez-moi une question, partagez ce qui vous préoccupe, ou dites simplement bonjour.",
    "chat.disclaimer": "Omni est un compagnon IA. Pas un professionnel agréé. En cas de crise, contactez les services d'urgence.",
    "chat.cbtDisclaimer": "Les exercices TCC sont uniquement destinés à l'auto-réflexion et ne remplacent pas une thérapie professionnelle.",
    "chat.export": "Exporter PDF", "chat.share": "Partager",
    "mood.title": "Humeur", "mood.howFeeling": "Comment vous sentez-vous ?", "mood.log": "Enregistrer",
    "mood.reminder": "Rappel quotidien", "mood.reminderDesc": "Recevez un rappel pour faire le point",
    "mood.reminderTime": "Heure du rappel", "mood.reminderToast": "Comment vous sentez-vous aujourd'hui ?",
    "goals.title": "Objectifs", "goals.create": "Nouvel objectif",
    "pricing.title": "Choisissez votre voie", "pricing.subtitle": "Commencez gratuitement. Évoluez quand vous êtes prêt.",
    "pricing.monthly": "Mensuel", "pricing.annual": "Annuel", "pricing.upgrade": "Passer au supérieur",
    "pricing.currentPlan": "Plan actuel", "pricing.checkout": "Paiement", "pricing.confirm": "Confirmer",
    "family.title": "Famille", "family.inviteCode": "Code d'invitation", "family.members": "Membres",
    "family.trends": "Tendances émotionnelles", "family.trendsDesc": "Voyez comment va votre famille. Les messages privés ne sont jamais visibles.",
    "settings.title": "Paramètres", "settings.appearance": "Apparence", "settings.voice": "Voix",
    "settings.language": "Langue", "settings.languageDesc": "Change les réponses IA et la langue de l'interface",
    "settings.profile": "Profil", "settings.save": "Enregistrer",
    "settings.privacy": "Confidentialité", "settings.deleteAccount": "Supprimer le compte",
    "common.loading": "Chargement...", "common.save": "Enregistrer",
  },

  // --- Spanish ---
  es: {
    "nav.chat": "Chat", "nav.mood": "Ánimo", "nav.goals": "Metas",
    "nav.plans": "Planes", "nav.family": "Familia", "nav.settings": "Ajustes", "nav.logout": "Cerrar sesión",
    "chat.newChat": "Nuevo chat", "chat.placeholder": "¿Qué tienes en mente?",
    "chat.hello": "Hola,", "chat.welcome": "Estoy aquí cuando me necesites. Pregúntame lo que quieras o simplemente saluda.",
    "chat.disclaimer": "Omni es un compañero IA. No es un profesional. En crisis, contacta servicios de emergencia.",
    "chat.export": "Exportar PDF", "chat.share": "Compartir",
    "mood.title": "Ánimo", "mood.howFeeling": "¿Cómo te sientes?", "mood.log": "Registrar",
    "mood.reminder": "Recordatorio diario", "mood.reminderDesc": "Recibe un recordatorio para hacer un check-in contigo",
    "goals.title": "Metas", "goals.create": "Nueva meta",
    "pricing.title": "Elige tu camino", "pricing.subtitle": "Empieza gratis. Crece cuando estés listo.",
    "settings.title": "Ajustes", "settings.language": "Idioma", "settings.profile": "Perfil",
    "common.loading": "Cargando...",
  },

  // --- Portuguese ---
  pt: {
    "nav.chat": "Chat", "nav.mood": "Humor", "nav.goals": "Metas",
    "nav.plans": "Planos", "nav.family": "Família", "nav.settings": "Configurações", "nav.logout": "Sair",
    "chat.newChat": "Novo chat", "chat.placeholder": "O que está pensando?",
    "chat.hello": "Olá,", "chat.welcome": "Estou aqui quando precisar. Pergunte o que quiser ou apenas diga olá.",
    "chat.disclaimer": "Omni é um companheiro IA. Não é um profissional. Em crise, contacte emergências.",
    "mood.title": "Humor", "mood.reminder": "Lembrete diário",
    "goals.title": "Metas", "settings.title": "Configurações", "settings.language": "Idioma",
    "common.loading": "Carregando...",
  },

  // --- Italian ---
  it: {
    "nav.chat": "Chat", "nav.mood": "Umore", "nav.goals": "Obiettivi",
    "nav.plans": "Piani", "nav.family": "Famiglia", "nav.settings": "Impostazioni", "nav.logout": "Esci",
    "chat.newChat": "Nuova chat", "chat.placeholder": "Cosa hai in mente?",
    "chat.hello": "Ciao,", "chat.welcome": "Sono qui quando hai bisogno. Chiedimi qualsiasi cosa o salutami.",
    "chat.disclaimer": "Omni è un compagno IA. Non è un professionista. In caso di crisi, contatta i servizi di emergenza.",
    "mood.title": "Umore", "mood.reminder": "Promemoria giornaliero",
    "goals.title": "Obiettivi", "settings.title": "Impostazioni", "settings.language": "Lingua",
    "common.loading": "Caricamento...",
  },

  // --- German ---
  de: {
    "nav.chat": "Chat", "nav.mood": "Stimmung", "nav.goals": "Ziele",
    "nav.plans": "Pläne", "nav.family": "Familie", "nav.settings": "Einstellungen", "nav.logout": "Abmelden",
    "chat.newChat": "Neuer Chat", "chat.placeholder": "Was beschäftigt dich?",
    "chat.hello": "Hallo,", "chat.welcome": "Ich bin hier, wenn du mich brauchst. Frag mich alles oder sag einfach Hallo.",
    "chat.disclaimer": "Omni ist ein KI-Begleiter. Kein lizenzierter Fachmann. Im Notfall den Rettungsdienst kontaktieren.",
    "mood.title": "Stimmung", "mood.reminder": "Tägliche Erinnerung",
    "goals.title": "Ziele", "settings.title": "Einstellungen", "settings.language": "Sprache",
    "common.loading": "Laden...",
  },

  // --- Yoruba ---
  yo: {
    "nav.chat": "Ìjíròrò", "nav.mood": "Ìmọ̀lára", "nav.goals": "Àfojúsùn",
    "nav.plans": "Àwọn ètò", "nav.family": "Ẹbí", "nav.settings": "Ètò", "nav.logout": "Jáde",
    "chat.newChat": "Ìjíròrò tuntun", "chat.placeholder": "Kí ló wà lọ́kàn rẹ?",
    "chat.hello": "Ẹ kú,", "chat.welcome": "Mo wà níbí nígbà tí o bá nílò mi.",
    "mood.title": "Ìmọ̀lára", "goals.title": "Àfojúsùn", "settings.title": "Ètò",
    "settings.language": "Èdè", "common.loading": "Ń gbéjáde...",
  },

  // --- Hausa ---
  ha: {
    "nav.chat": "Hira", "nav.mood": "Yanayi", "nav.goals": "Manufofin",
    "nav.plans": "Tsare-tsare", "nav.family": "Iyali", "nav.settings": "Saiti", "nav.logout": "Fita",
    "chat.newChat": "Sabuwar hira", "chat.placeholder": "Me ke cikin tunaninka?",
    "chat.hello": "Sannu,", "chat.welcome": "Ina nan ko yaushe kake bukata.",
    "mood.title": "Yanayi", "goals.title": "Manufofin", "settings.title": "Saiti",
    "settings.language": "Harshe", "common.loading": "Ana lodawa...",
  },

  // --- Igbo ---
  ig: {
    "nav.chat": "Mkparịta ụka", "nav.mood": "Mmetụta", "nav.goals": "Ebumnuche",
    "nav.plans": "Atụmatụ", "nav.family": "Ezinụlọ", "nav.settings": "Ntọala", "nav.logout": "Pụọ",
    "chat.newChat": "Mkparịta ụka ọhụrụ", "chat.placeholder": "Gịnị dị n'uche gị?",
    "chat.hello": "Nnọọ,", "chat.welcome": "Anọ m ebe a mgbe ọ bụla ị chọrọ m.",
    "mood.title": "Mmetụta", "goals.title": "Ebumnuche", "settings.title": "Ntọala",
    "settings.language": "Asụsụ", "common.loading": "Na-ebu...",
  },

  // --- Nigerian Pidgin ---
  pcm: {
    "nav.chat": "Yarn", "nav.mood": "How You Dey", "nav.goals": "Wetin You Wan",
    "nav.plans": "Plans", "nav.family": "Family", "nav.settings": "Settings", "nav.logout": "Comot",
    "chat.newChat": "New Yarn", "chat.placeholder": "Wetin dey your mind?",
    "chat.hello": "Hey,", "chat.welcome": "I dey here for you anytime. Just talk to me.",
    "mood.title": "How You Dey", "goals.title": "Wetin You Wan", "settings.title": "Settings",
    "settings.language": "Language", "common.loading": "E dey load...",
  },

  // --- Dutch ---
  nl: { "nav.chat": "Chat", "nav.mood": "Stemming", "nav.goals": "Doelen", "nav.settings": "Instellingen",
    "settings.language": "Taal", "common.loading": "Laden...", "nav.logout": "Uitloggen" },
  // --- Polish ---
  pl: { "nav.chat": "Czat", "nav.mood": "Nastrój", "nav.goals": "Cele", "nav.settings": "Ustawienia",
    "settings.language": "Język", "common.loading": "Ładowanie...", "nav.logout": "Wyloguj" },
  // --- Swedish ---
  sv: { "nav.chat": "Chatt", "nav.mood": "Humör", "nav.goals": "Mål", "nav.settings": "Inställningar",
    "settings.language": "Språk", "common.loading": "Laddar...", "nav.logout": "Logga ut" },
  // --- Russian ---
  ru: { "nav.chat": "Чат", "nav.mood": "Настроение", "nav.goals": "Цели", "nav.settings": "Настройки",
    "settings.language": "Язык", "common.loading": "Загрузка...", "nav.logout": "Выйти" },
  // --- Arabic ---
  ar: { "nav.chat": "محادثة", "nav.mood": "المزاج", "nav.goals": "الأهداف", "nav.settings": "الإعدادات",
    "settings.language": "اللغة", "common.loading": "جاري التحميل...", "nav.logout": "تسجيل الخروج" },
  // --- Turkish ---
  tr: { "nav.chat": "Sohbet", "nav.mood": "Ruh hali", "nav.goals": "Hedefler", "nav.settings": "Ayarlar",
    "settings.language": "Dil", "common.loading": "Yükleniyor...", "nav.logout": "Çıkış" },
  // --- Hindi ---
  hi: { "nav.chat": "चैट", "nav.mood": "मूड", "nav.goals": "लक्ष्य", "nav.settings": "सेटिंग्स",
    "settings.language": "भाषा", "common.loading": "लोड हो रहा है...", "nav.logout": "लॉग आउट" },
};

export default translations;
